import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        flexGrow: 1,
        position: 'relative' as const
    },
    userFullNameContainer: { whiteSpace: 'normal' as const },
    cancelButton: {
        position: 'absolute' as const,
        top: '1rem',
        right: '1rem'
    },
    userContainer: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '2rem'
    },
    userHeaderContainer: { paddingBottom: '1rem' },
    actionButton: { marginRight: '1rem' },
    userFullName: {
        fontSize: '1.75rem',
        wordBreak: 'break-word' as const,
        paddingRight: '5px'
    },
    userLockedIcon: {
        marginLeft: '.75rem',
        paddingTop: '.2rem'
    },
    userTabsContainer: {
        borderTop: '1px solid #BFBFBF',
        borderBottom: '1px solid #BFBFBF'
    },
    userTab: { padding: 0 },
    indicator: {
        height: '5px',
        background: theme?.app?.clientTheme.colors.highlightColor1 ||
            '#EDDA26'
    }
});